export default __webpack_public_path__ + "static/media/armin_xl.0d181c64.jpg";